import { Checkbox, styled } from "@mui/material";
import { StyledTableCell } from "../style";

const SelectTableCell = styled(StyledTableCell)`
  padding-inline: 2px 0;
`;

export default function Select(args) {
  return (
    <SelectTableCell {...args}>
      <Checkbox />
    </SelectTableCell>
  );
}
